module.exports = ".btn-primary, .btn-primary:hover, .btn-primary:active, .btn-primary:focus {\n    background-color: #0d0d80;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/upload/upload.component.css
// module id = ./src/app/modules/shared/upload/upload.component.css
// module chunks = main